module.exports = __webpack_public_path__ + "static/media/VU1950F0.f832d044.png";